import React, { useState } from 'react';
import styled from 'styled-components';
import VideoLectureIndexChapter, { LectureChapter } from './VideoLectureIndexChapter';

interface VideoLectureIndexProps {
  chapters: LectureChapter[];
  currentChapterOrder: number;
  currentSessionOrder: number;
}

function VideoLectureIndex({ chapters, currentChapterOrder, currentSessionOrder }: VideoLectureIndexProps) {
  const [openChapterIndex, setOpenChapterIndex] = useState<number | null>(currentChapterOrder);

  const handleClickChapterTitle = (order: number) => () =>
    setOpenChapterIndex((prev) => (prev !== order ? order : null));

  return (
    <StyledContainer>
      {chapters.map((chapter) => (
        <li key={chapter.title}>
          <VideoLectureIndexChapter
            chapter={chapter}
            isOpen={chapter.order === openChapterIndex}
            onClickChapterTitle={handleClickChapterTitle(chapter.order)}
            currentChapterOrder={currentChapterOrder}
            currentSessionOrder={currentSessionOrder}
          />
        </li>
      ))}
    </StyledContainer>
  );
}

const StyledContainer = styled.ol`
  list-style: none;
  padding-left: 0;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 10px;
  margin: 0;
`;

export default VideoLectureIndex;
